import React from 'react';
import { Query } from 'react-apollo';

import query from './SchedulingPageQuery.graphql';
import { DILM_CLIENT_CONTEXT } from '../../../shared/constants';

export default function SchedulingPageQuery({ children, id, token }) {
  return (
    <Query query={query} variables={{ id, token }} context={DILM_CLIENT_CONTEXT}>
      {({ data, loading, error, refetch }: any) => {
        if (error || loading || !data) {
          return children({
            error,
            loading,
            scheduleRequestAttempt: undefined,
            refetch,
          });
        }

        const { scheduleRequestAttempt } = data;

        return children({
          error,
          loading,
          scheduleRequestAttempt,
          refetch,
        });
      }}
    </Query>
  );
}
